import { axiosInstance } from "lib/axios";
import { searchAPI } from "services/apis.service";
import {
  ebscoLabel,
  proQuestLabel,
} from "features/SourceSearch/data/search-fields.data";

const databaseDisplayNames = {
  Ebsco: ebscoLabel,
  ProQuest: proQuestLabel,
};

export const getDatabaseApiName = (database) => {
  const normalizedDatabase = String(database).toLowerCase();
  if (normalizedDatabase === "ebsco") return "Ebsco";
  if (normalizedDatabase === "proquest") return "ProQuest";
  return database;
};

export const getDatabaseDisplayName = (database) => {
  const apiName = getDatabaseApiName(database);
  return databaseDisplayNames[apiName] || database;
};

const getWebPages = (section) => {
  const webPages = section?.webPages || section?.data?.webPages || section?.Data?.webPages;
  if (!webPages) return webPages;
  const pagination = section?.pagination || section?.data?.pagination || section?.Data?.pagination || webPages.pagination;
  return {
    ...webPages,
    totalEstimatedMatches: pagination?.totalCount ?? webPages.totalEstimatedMatches,
  };
};

export const normalizeDatabaseSearchSections = (data, databases) => {
  if (Array.isArray(data?.results)) {
    return data.results.map((result) => ({
      ...result,
      media: getDatabaseDisplayName(result.media || result.database || result.databaseName),
      webPages: getWebPages(result) || result.webPages,
    }));
  }

  if (Array.isArray(data)) {
    return data.map((result) => ({
      ...result,
      media: getDatabaseDisplayName(result.media || result.database || result.databaseName),
      webPages: getWebPages(result) || result.webPages,
    }));
  }

  if (data?.webPages) {
    const database = databases?.[0];
    return [
      {
        media: getDatabaseDisplayName(database),
        webPages: getWebPages(data),
      },
    ];
  }

  return (databases || [])
    .map((database) => {
      const section = data?.[database] || data?.[getDatabaseDisplayName(database)];
      const webPages = getWebPages(section) || section?.webPages;
      if (!webPages) return null;
      return {
        ...section,
        media: getDatabaseDisplayName(database),
        webPages,
      };
    })
    .filter(Boolean);
};

export const getDatabaseSearch = async (
  searchTerm,
  timePeriod,
  databases,
  pageNumber,
  pageSize = 21
) => {
  const isEbscoSearch = (databases || []).some(
    (database) => getDatabaseApiName(database) === "Ebsco"
  );
  const omitEbscoTimePeriod =
    isEbscoSearch && (timePeriod == null || timePeriod === "");
  const { data } = await axiosInstance.post(searchAPI.databaseSearch, {
    searchTerm,
    ...(!omitEbscoTimePeriod && { timePeriod }),
    databases: (databases || []).map(getDatabaseApiName),
    pageNumber,
    pageSize,
  });

  return data.data;
};
